import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EventNotificationsStore } from "stores/event-notifications/EventNotificationsStore";
import { defaultOnError } from "util/conditional/onError";
export const fetchEventNotifications = (searchParams) => EventNotificationsStore.searchPaginated(searchParams.page, searchParams.pageSize, searchParams.query, {
  sort: searchParams == null ? void 0 : searchParams.sort.attributeId,
  order: searchParams == null ? void 0 : searchParams.sort.direction
}).then(({ elements, pagination, attributes }) => ({
  list: elements,
  pagination,
  attributes
}));
export const keyFn = (searchParams) => [
  "eventNotifications",
  "overview",
  ...searchParams ? [searchParams] : []
];
const useEventNotifications = (searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchEventNotifications(searchParams),
      "Loading event notifications failed with status",
      "Could not load event notifications"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data,
    refetch,
    isInitialLoading
  };
};
export default useEventNotifications;
